import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

const MagazineListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  transition: all 0.25s;
  padding: 0px 16px;
  margin-right: 20px;

  @media (${breakpoint.mdMin}) {
    column-gap: 24px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
  }

  @media (${breakpoint.lgMin}) {
    column-gap: 24px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  @media (${breakpoint.xxlMin}) {
    column-gap: 48px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  @media (${breakpoint.hybridMax}) {
    margin-right: 0;
  }

  .ad-div {
    grid-column: span 2;

    @media (${breakpoint.lgMin}) {
      grid-column: span 3;
    }
  }
`;

export default MagazineListWrapper;
